module.exports = __webpack_public_path__ + "static/media/Roma.5cf8b99d.png";